module.exports = __webpack_public_path__ + "img/3.8ea01109.png";